var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, Input, NgZone } from '@angular/core';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { AlertifyService } from '../../../services/alertify.service';
import { BulkAIDescriptionsStore } from '../../../stores/hub.calendar.store';
import { ModalService } from '../../../common/services/modal.service';
var BulkAIDescriptionsModalComponent = /** @class */ (function (_super) {
    __extends(BulkAIDescriptionsModalComponent, _super);
    function BulkAIDescriptionsModalComponent(imageService, cdRef, hubApiService, bulkAIDescriptionsStore, modalService, alertify) {
        var _this = _super.call(this) || this;
        _this.imageService = imageService;
        _this.cdRef = cdRef;
        _this.hubApiService = hubApiService;
        _this.bulkAIDescriptionsStore = bulkAIDescriptionsStore;
        _this.modalService = modalService;
        _this.alertify = alertify;
        _this.places = [];
        _this.isCornerView = false;
        _this.progress = 0;
        _this.context = ''; // city name for AI as context
        _this.isCancel = false;
        _this.isAskForCancel = false;
        _this.isCommandReceived = false;
        bulkAIDescriptionsStore.bulkAIDescriptionsCommand.subscribe(function (command) {
            // avoid this receives multiple commands when you close and open this modal multiple times
            if (_this.isCommandReceived)
                return;
            _this.isCommandReceived = true;
            _this.hubName = command;
            _this.hubApiService.getNoDescriptionPlaces(_this.hubName).subscribe(function (places) {
                console.log(places);
                _this.places = places;
                _this.cdRef.detectChanges();
                // get the city name of these places
                if (places.length) {
                    var place = places.first(function (place) { return !!place.address_components; });
                    if (place && place.address_components) {
                        _this.context = _this.getPlaceCity(place);
                        console.log('context', _this.context);
                    }
                }
            });
        });
        return _this;
    }
    BulkAIDescriptionsModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var groupedPlaces, i, group, start, index, _loop_1, this_1, _i, groupedPlaces_1, group, state_1, end;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isCornerView = true;
                        this.progress = 1; // set progress to 1 so that we can display some relates UI elements to indicate the status
                        this.cdRef.detectChanges();
                        groupedPlaces = [];
                        for (i = 0; i < this.places.length; i += 10) {
                            group = this.places.slice(i, i + 10);
                            groupedPlaces.push(group);
                        }
                        console.log('groupedPlaces', groupedPlaces);
                        start = new Date().getTime();
                        index = 1;
                        _loop_1 = function (group) {
                            var result, data, json_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (this_1.isCancel) {
                                            console.log('cancel');
                                            return [2 /*return*/, { value: void 0 }];
                                        }
                                        return [4 /*yield*/, this_1.hubApiService
                                                .aiAssistant(this_1.hubName, {
                                                context: this_1.context,
                                                query: group.map(function (p) { return "{\"name\": \"" + p.name + ", " + _this.getPlaceCity(p) + "\", \"id\": \"" + p._id + "\"}"; }).join('; '),
                                                feature: 'bulk-place-descriptions',
                                            })
                                                .toPromise()];
                                    case 1:
                                        result = _a.sent();
                                        if (result.success) {
                                            data = result.data.replace(/\\n/i, '');
                                            json_1 = JSON.parse(data);
                                            console.log(json_1);
                                            Object.keys(json_1).forEach(function (key) {
                                                var place = _this.places.find(function (x) { return x._id.toString() === key.toString(); });
                                                place && (place.description = json_1[key]);
                                                console.log(place);
                                            });
                                        }
                                        // calculate the progress, max value is 100
                                        this_1.progress = (index / groupedPlaces.length) * 100;
                                        this_1.cdRef.detectChanges();
                                        console.log('this.progress', this_1.progress);
                                        index++;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, groupedPlaces_1 = groupedPlaces;
                        _a.label = 1;
                    case 1:
                        if (!(_i < groupedPlaces_1.length)) return [3 /*break*/, 4];
                        group = groupedPlaces_1[_i];
                        return [5 /*yield**/, _loop_1(group)];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        end = new Date().getTime();
                        console.log((end - start) / 1000 + " sec");
                        return [2 /*return*/];
                }
            });
        });
    };
    BulkAIDescriptionsModalComponent.prototype.save = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var groupSize, index, group, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // trigger the loading animation
                        this.cdRef.detectChanges();
                        groupSize = 200;
                        index = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        _a.label = 2;
                    case 2:
                        if (!(index < this.places.length)) return [3 /*break*/, 4];
                        group = this.places.slice(index, index + groupSize);
                        return [4 /*yield*/, this.hubApiService.savePlacesDescriptions(this.hubName, group).toPromise()];
                    case 3:
                        _a.sent();
                        index += groupSize;
                        return [3 /*break*/, 2];
                    case 4:
                        this.close();
                        this.alertify.success('Place descriptions saved!');
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _a.sent();
                        this.alertify.error(error_1.message);
                        return [3 /*break*/, 7];
                    case 6:
                        event.complete();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    BulkAIDescriptionsModalComponent.prototype.checkStatus = function () {
        this.isCornerView = false;
        this.cdRef.detectChanges();
    };
    BulkAIDescriptionsModalComponent.prototype.hide = function () {
        this.isCornerView = true;
        this.cdRef.detectChanges();
    };
    BulkAIDescriptionsModalComponent.prototype.close = function () {
        if (this.progress > 0 && this.progress < 100 && !this.isCancel) {
            this.hide();
            return;
        }
        var modal = document.querySelector('ig-bulk-ai-descriptions-modal');
        modal && modal.remove();
    };
    BulkAIDescriptionsModalComponent.prototype.cancel = function () {
        this.isCancel = true;
        this.alertify.success('Place descriptions generation cancelled!');
        this.close();
    };
    BulkAIDescriptionsModalComponent.prototype.askForCancel = function () {
        this.isAskForCancel = true;
        this.cdRef.detectChanges();
    };
    Object.defineProperty(BulkAIDescriptionsModalComponent.prototype, "displayProgress", {
        get: function () {
            return Math.round(this.progress) + '%';
        },
        enumerable: true,
        configurable: true
    });
    BulkAIDescriptionsModalComponent.prototype.getPlaceCity = function (place) {
        if (place.address_components) {
            var level1 = place.address_components.find(function (x) { return x.types.any(function (y) { return y === 'administrative_area_level_1'; }); });
            var locality = place.address_components.find(function (x) { return x.types.any(function (y) { return y === 'locality'; }); });
            var context = level1 && locality ? locality.long_name + ", " + level1.long_name : '';
            return context;
        }
        return '';
    };
    BulkAIDescriptionsModalComponent.prototype.myWait = function (milSeconds) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve(null);
            }, milSeconds);
        });
    };
    return BulkAIDescriptionsModalComponent;
}(BaseComponent));
export { BulkAIDescriptionsModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component.ts.pre-build-optimizer.js